import {Button, Flex, Form, Table} from "antd";
import React, {useEffect, useState} from "react";
import {NotificationService} from "../../../services/NotificationService";
import {AdminHttpService} from "../../../services/Http/SearchTableService";

export interface BasicTableProps {
    columns: any,
    urlPath: string,
    rowKey?: string,
    loading?: boolean,
    filters?: React.ReactNode[];
}

interface BasicTableResponse<T> {
    totalSize: number,
    currentPage: number,
    pageSize: number,
    data: T[]
}

export type AnyObject = Record<string, any>; // A common definition for a generic object

export function BasicTable<T extends AnyObject>({
                                                    columns,
                                                    urlPath,
                                                    rowKey = 'id',
                                                    loading = false,
                                                    filters

                                                }: BasicTableProps) {


    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [dataList, setDataList] = useState<T[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(loading);

    // Search states
    const [searchForm] = Form.useForm();
    // const searcFormRef = useRef<any>();
    const [searchParams, setSearchParams] = useState<AnyObject>({});


    useEffect(() => {
        loadData(searchParams);
    }, [pagination.current, pagination.pageSize]);


    const loadData = async (criteria: AnyObject = {}) => {
        setIsLoading(true);
        try {
            const response = await AdminHttpService.get<BasicTableResponse<T>>(urlPath, {
                ...criteria,
                page: pagination.current - 1,
                size: pagination.pageSize
            });
            setDataList(response.data.data as T[])
            setPagination(prev => ({
                ...prev,
                total: response.data.totalSize
            }));
        } catch (e) {
            console.log(e);
            NotificationService.getInstance().openNotificationError("Impossibile caricare il dati")
        } finally {
            setIsLoading(false);
        }
    };

    const onSearch = (name: string) => {
        // Get the search params
        const initialCriteria: AnyObject = searchForm.getFieldsValue();
        const criteria: AnyObject = {};

        // Do not include the search param if the value is empty
        for (const key in initialCriteria) {
            if (initialCriteria.hasOwnProperty(key)) {
                const value = initialCriteria[key];
                if (typeof value === 'string' && value.trim() === '') {
                    continue;
                }
                criteria[key] = value;
            }
        }

        setSearchParams(criteria);

        // Reset pagination
        setPagination(prev => ({...prev, current: 1}))
        loadData(criteria);
    }

    const cleanSearchForm = () => {
        searchForm.resetFields();
    };

    const getSearchForm = () => {
        return <><Form form={searchForm}
                       onFinish={onSearch}
                       className={"form-filter"}
        >
            <Flex wrap="wrap" gap="large">
                {filters}
                <Button onClick={cleanSearchForm} htmlType="reset">Pulisci</Button>
                <Button type={"primary"} htmlType="submit" onClick={() => {
                    searchForm.submit()
                }}>Applica</Button>
            </Flex>
        </Form>
            <>
            </>
        </>
    }

    const getBasicTable = () => {
        return <Table columns={columns}
                      dataSource={dataList}
                      rowKey={rowKey}
                      loading={isLoading}
                      pagination={{
                          current: pagination.current,
                          pageSize: pagination.pageSize,
                          total: pagination.total,
                          onChange: (page, pageSize) => {
                              setPagination(prev => ({
                                  ...prev,
                                  current: page,
                                  pageSize: pageSize
                              }));
                          }
                      }}
        >
        </Table>
    }

    return <>
        {filters && filters.length ?
            getSearchForm() : undefined}

        {getBasicTable()}
    </>
}